<wms-dialog [id]="id"   [attr.id]="id"  customClasses="small sync-vcs-project-dialog wm-studio-dialog">
    <wms-dialog-header (onClose)="vcsService.closeDialogWithId(vcsAction ==='pull' ? 'pullChangesModal' : 'pushExternalRepoChangesModal')"
        title="{{vcsAction ==='pull' ? locale['LABEL_PULL_CONFIRM'] : locale['LABEL_VCS_MENU_PUSH_PROJECT']}}"
        helpLink="{{vcsAction === 'pushExternal' ? 'https://docs.wavemaker.com/learn/app-development/dev-integration/developer-collaboration/#push-changes' :''}}"
        customClass="pullChanges-header"></wms-dialog-header>
    <wms-dialog-body>
        <p> {{ vcsAction ==='pull' ? locale['MESSAGE_PULL_CONFIRM']: locale['MESSAGE_VCS_PROJECT_PUSH_MESSAGE']}}</p>
    </wms-dialog-body>
    <wms-dialog-footer>
        <ng-container *ngIf="vcsAction ==='pull';else pushBtn">
            <button class="btn button-secondary app-button"
            (click)="closeDialog()">{{locale['LABEL_CANCEL']}}</button>
        <button class="btn btn-primary" (click)="pullProjectChanges()">{{locale['LABEL_OK']}}</button>
        </ng-container>
        <ng-template #pushBtn>
            <button class="btn button-secondary app-button"
            (click)="closeDialog()">{{locale['LABEL_NO']}}</button>
        <button class="btn btn-primary" (click)="vcsService.openPushDialog()">{{locale['LABEL_YES']}}</button>
        </ng-template>
    </wms-dialog-footer>
</wms-dialog>
